import { deserializeBirthDate, serializeBirthDate } from 'client-portal/utils/birth-date';
import Transform from '@ember-data/serializer/transform';

export default class BirthDateTransform extends Transform {
  deserialize(serialized) {
    return deserializeBirthDate(serialized);
  }

  serialize(deserialized) {
    return serializeBirthDate(deserialized);
  }
}
